import { Injectable } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';

const overridesEsAR: Record<string, string> = {
  // Grid
  "kendo.grid.groupPanelEmpty": "Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio",
  "kendo.grid.noRecords": "No hay datos disponibles.",
  "kendo.grid.pagerFirstPage": "Ir a la primera página",
  "kendo.grid.pagerPreviousPage": "Ir a la página anterior",
  "kendo.grid.pagerNextPage": "Ir a la página siguiente",
  "kendo.grid.pagerLastPage": "Ir a la última página",
  "kendo.grid.pagerPage": "Página",
  "kendo.grid.pagerOf": "de",
  "kendo.grid.pagerItems": "ítems",
  "kendo.grid.pagerItemsPerPage": "ítems por página",
  "kendo.grid.pagerPageNumberInputTitle": "Número de Página",
  "kendo.grid.filter": "Filtrar",
  "kendo.grid.filterEqOperator": "Es igual a",
  "kendo.grid.filterNotEqOperator": "No es igual a",
  "kendo.grid.filterIsNullOperator": "Es nulo",
  "kendo.grid.filterIsNotNullOperator": "No es nulo",
  "kendo.grid.filterIsEmptyOperator": "Está vacío",
  "kendo.grid.filterIsNotEmptyOperator": "No está vacío",
  "kendo.grid.filterStartsWithOperator": "Comienza con",
  "kendo.grid.filterContainsOperator": "Contiene",
  "kendo.grid.filterNotContainsOperator": "No contiene",
  "kendo.grid.filterEndsWithOperator": "Termina en",
  "kendo.grid.filterGteOperator": "Es mayor o igual que",
  "kendo.grid.filterGtOperator": "Es mayor que",
  "kendo.grid.filterLteOperator": "Es menor o igual que",
  "kendo.grid.filterLtOperator": "Es menor o igual que",
  "kendo.grid.filterIsTrue": "Sí",
  "kendo.grid.filterIsFalse": "No",
  "kendo.grid.filterBooleanAll": "(Todas)",
  "kendo.grid.filterAfterOrEqualOperator": "Es posterior o igual a",
  "kendo.grid.filterAfterOperator": "Es posterior",
  "kendo.grid.filterBeforeOperator": "Es anterior",
  "kendo.grid.filterBeforeOrEqualOperator": "Es anterior o igual a",
  "kendo.grid.filterFilterButton": "Filtrar",
  "kendo.grid.filterClearButton": "Limpiar filtros",
  "kendo.grid.filterAndLogic": "Y",
  "kendo.grid.filterOrLogic": "O",
  "kendo.grid.filterDateToggle": "Mostrar calendario",
  "kendo.grid.filterDateToday": "Hoy",
  "kendo.grid.filterNumericDecrement": "Disminuir valor",
  "kendo.grid.filterNumericIncrement": "Incrementar valor",
  "kendo.grid.loading": "Cargando",
  "kendo.grid.columns": "Columnas",
  "kendo.grid.lock": "Bloquear",
  "kendo.grid.unlock": "Desbloquear",
  "kendo.grid.stick": "Stick",
  "kendo.grid.unstick": "Unstick",
  "kendo.grid.setColumnPosition": "Setear posición de columna",
  "kendo.grid.sortAscending": "Orden ascendente",
  "kendo.grid.sortDescending": "Orden descendente",
  "kendo.grid.columnsApply": "Aplicar",
  "kendo.grid.columnsReset": "Defecto",
  "kendo.grid.sortable": "Ordenable",
  "kendo.grid.sortedAscending": "Ordenado ascendentemente",
  "kendo.grid.sortedDescending": "Ordenado descendentemente",
  "kendo.grid.sortedDefault": "No ordenado",
  "kendo.grid.filterInputLabel": "{columnName} Filtro",
  "kendo.grid.filterMenuTitle": "{columnName} Menú de Filtro",
  "kendo.grid.filterMenuOperatorsDropDownLabel": "{columnName} Operadores de Filtro",
  "kendo.grid.filterMenuLogicDropDownLabel": "{columnName} Lógica de Filtro",
  "kendo.grid.columnMenu": "{columnName} Menú de Columna",
  "kendo.grid.selectionCheckboxLabel": "Seleccionar Fila",
  "kendo.grid.selectAllCheckboxLabel": "Seleccionar Todas las Filas",
  "kendo.grid.pagerLabel": "Navegación de página, página {currentPage} de {totalPages}",
  "kendo.grid.gridLabel": "Tabla de datos",
  "kendo.grid.groupCollapse": "Contraer Grupo",
  "kendo.grid.groupExpand": "Expandir Grupo",
  "kendo.grid.detailCollapse": "Contraer Detalles",
  "kendo.grid.detailExpand": "Expandir Detalles",
  "kendo.grid.autosizeThisColumn": "Ajustar tamaño de esta columna",
  "kendo.grid.autosizeAllColumns": "Ajustar tamaño de todas las columnas",
  "kendo.grid.pagerSelectPage": "Seleccionar página",
  "kendo.grid.topToolbarLabel": "Barra de herramientas superior",
  "kendo.grid.bottomToolbarLabel": "Barra de herramientas inferior",
  "kendo.grid.groupPanelLabel": "Panel de grupo",
  "kendo.grid.dragRowHandleLabel": "Arrastrar fila",
  "kendo.grid.selectRowCheckboxLabel": "Seleccionar fila",
  "kendo.grid.selectAllRowsCheckboxLabel": "Seleccionar todas las filas",
  "kendo.grid.filterCellOperatorLabel": "Operadores de celda de filtro para {columnName}",
  "kendo.grid.booleanFilterCellLabel": "Celda de filtro booleano para {columnName}",
  "kendo.grid.columnMenuFilterTabTitle": "Filtro",
  "kendo.grid.columnMenuGeneralTabTitle": "General",
  "kendo.grid.columnMenuColumnsTabTitle": "Columnas",
  "kendo.grid.groupChipMenuPrevious": "Mover antes",
  "kendo.grid.groupChipMenuNext": "Mover después",
  "kendo.grid.pagerInputLabel": "Type a page number",
  "kendo.grid.formValidationErrorText": "The {fieldName} field has {errorName} validation error",
  "kendo.grid.removeConfirmationDialogTitle": "Please confirm",
  "kendo.grid.removeConfirmationDialogContent": "Are you sure you want to delete this item?",
  "kendo.grid.removeConfirmationDialogConfirmText": "Sí",
  "kendo.grid.removeConfirmationDialogRejectText": "No",
  "kendo.grid.externalEditingTitle": "Editar",
  "kendo.grid.externalEditingSaveText": "Guardar",
  "kendo.grid.externalEditingCancelText": "Cancelar",
  "kendo.grid.sortClearButton": "Limpiar ordenamiento",
  "kendo.grid.adaptiveCloseButtonTitle": "Cerrar",
  "kendo.grid.adaptiveBackButtonTitle": "Volver",
  "kendo.grid.filterClearAllButton": "Limpiar todos los filtros",
  "kendo.grid.sortDoneButton": "Done",
  "kendo.grid.columnsSubtitle": "Selected fields are visible",
  "kendo.grid.adaptiveFilterTitle": "Filtrar por",
  "kendo.grid.adaptiveFilterOperatorsTitle": "Operadores",
  "kendo.grid.adaptiveSortTitle": "Ordenar por",
  "kendo.grid.externalEditingAddTitle": "Add",
  "kendo.grid.adaptiveGroupTitle": "Group by",
  "kendo.grid.groupClearButton": "Clear grouping",
  "kendo.grid.groupToolbarToolText": "Group",
  "kendo.grid.groupDoneButton": "Done",
  "kendo.grid.aiAssistantToolbarToolText": "AI Assistant",
  "kendo.grid.aiAssistantWindowTitle": "AI Assistant",
  "kendo.grid.aiAssistantApplyButtonText": "Apply",
  "kendo.grid.aiAssistantWindowCloseTitle": "Close",
  "kendo.grid.aiAssistantWindowMaximizeTitle": "Maximize",
  "kendo.grid.aiAssistantWindowMinimizeTitle": "Minimize",
  "kendo.grid.aiAssistantWindowRestoreTitle": "Restore",
  "kendo.grid.aiAssistantOutputCardTitle": "Generated with AI",
  "kendo.grid.aiAssistantOutputCardBodyContent": "Operation is successful. Data is:",
  "kendo.grid.multiCheckboxFilterSearchPlaceholder": "Search...",
  "kendo.grid.multiCheckboxFilterSelectAllLabel": "Select all",
  "kendo.grid.multiCheckboxFilterSelectedItemsCount": "\"{selectedItemsCount}\" selected items",

  // DropDown
  "kendo.autocomplete.noDataText": "No se encontraron datos",
  "kendo.autocomplete.clearTitle": "limpiar",
  "kendo.autocomplete.popupLabel": "Lista de opciones",
  "kendo.combobox.noDataText": "No se encontraron datos",
  "kendo.combobox.clearTitle": "limpiar",
  "kendo.combobox.selectButtonText": "Seleccionar",
  "kendo.combobox.popupLabel": "Lista de opciones",
  "kendo.dropdownlist.noDataText": "No se encontraron datos",
  "kendo.dropdownlist.clearTitle": "limpiar",
  "kendo.dropdownlist.selectButtonText": "Seleccionar",
  "kendo.dropdownlist.popupLabel": "Lista de opciones",
  "kendo.dropdownlist.filterInputLabel": "Filtrar",
  "kendo.dropdowntree.noDataText": "No se encontraron datos",
  "kendo.dropdowntree.clearTitle": "limpiar",
  "kendo.dropdowntree.selectButtonText": "Seleccionar",
  "kendo.dropdowntree.popupLabel": "Lista de opciones",
  "kendo.dropdowntree.filterInputLabel": "Filtrar",
  "kendo.multiselecttree.noDataText": "No se encontraron datos",
  "kendo.multiselecttree.clearTitle": "limpiar",
  "kendo.multiselecttree.selectButtonText": "Seleccionar",
  "kendo.multiselecttree.popupLabel": "Lista de opciones",
  "kendo.multiselecttree.filterInputLabel": "Filtrar",
  "kendo.multiselecttree.applyButton": "Aplicar",
  "kendo.multiselecttree.cancelButton": "Cancelar",
  "kendo.multiselecttree.checkAllText": "Seleccionar todo",
  "kendo.multicolumncombobox.noDataText": "No se encontraron datos",
  "kendo.multicolumncombobox.clearTitle": "limpiar",
  "kendo.multicolumncombobox.popupLabel": "Lista de opciones",
  "kendo.multiselect.noDataText": "No se encontraron datos",
  "kendo.multiselect.clearTitle": "limpiar",
  "kendo.multiselect.popupLabel": "Lista de opciones",
  "kendo.multiselect.applyButton": "Aplicar",
  "kendo.multiselect.cancelButton": "Cancelar",
  "kendo.multiselect.useCustomValueText": "Use \"{customValue}\"",

  // DatePicker / Calendar
  "kendo.datepicker.today": "Hoy",
  "kendo.datepicker.toggle": "Toggle calendar",
  "kendo.datepicker.prevButtonTitle": "Navegar a la vista previa",
  "kendo.datepicker.nextButtonTitle": "Navegar a la siguiente vista",
  "kendo.datepicker.parentViewButtonTitle": "Navigate to parent view",
  "kendo.datepicker.clearTitle": "Limpiar",

  // TimePicker / DateTimePicker
 "kendo.datetimepicker.dateTab": "Fecha",
  "kendo.datetimepicker.dateTabLabel": "Mostrar fecha",
  "kendo.datetimepicker.timeTab": "Hora",
  "kendo.datetimepicker.timeTabLabel": "Mostrar hora",
  "kendo.datetimepicker.toggle": "Cambiar calendario",
  "kendo.datetimepicker.accept": "Acceptar",
  "kendo.datetimepicker.acceptLabel": "Acceptar",
  "kendo.datetimepicker.cancel": "Cancelar",
  "kendo.datetimepicker.cancelLabel": "Cancelar",
  "kendo.datetimepicker.now": "AHORA",
  "kendo.datetimepicker.nowLabel": "Ahora",
  "kendo.datetimepicker.today": "HOY",
  "kendo.datetimepicker.prevButtonTitle": "Navegar a la vista previa",
  "kendo.datetimepicker.nextButtonTitle": "Navegar a la siguiente vista",
  "kendo.datetimepicker.hour": "Hora",
  "kendo.datetimepicker.minute": "Minuto",
  "kendo.datetimepicker.second": "Segundo",
  "kendo.datetimepicker.millisecond": "Milisegundo",
  "kendo.datetimepicker.dayperiod": "Dayperiod",
  "kendo.datetimepicker.parentViewButtonTitle": "Navigate to parent view",
  "kendo.datetimepicker.clearTitle": "limpiar",

  // Upload
  'kendo.upload.selectFiles': 'Seleccionar archivos...',
  'kendo.upload.clearSelectedFiles': 'Limpiar',
  'kendo.upload.uploadSelectedFiles': 'Subir',
  'kendo.upload.dropFilesHere': 'Arrastre archivos aquí para subir',
  'kendo.upload.statusUploading': 'Subiendo...',
  'kendo.upload.statusUploaded': 'Subido',
  'kendo.upload.statusWarning': 'Advertencia',
  'kendo.upload.statusFailed': 'Error',
  'kendo.upload.retry': 'Reintentar',
  'kendo.upload.remove': 'Eliminar',
  'kendo.upload.cancel': 'Cancelar',

  // Pager
  "kendo.pager.firstPage": "Ir a la primera página",
  "kendo.pager.previousPage": "Ir a la página anterior",
  "kendo.pager.nextPage": "Ir a la página siguiente",
  "kendo.pager.lastPage": "Ir a la última página",
  "kendo.pager.page": "Página",
  "kendo.pager.of": "de",
  "kendo.pager.items": "ítems",
  "kendo.pager.itemsPerPage": "ítems por página",
  "kendo.pager.pageNumberInputTitle": "Número de página",
  "kendo.pager.selectPage": "Seleccionar página",
  "kendo.pager.inputLabel": "Type a page number",

  // Scheduler (parcial)
  "kendo.recurrenceeditor.dailyInterval": "día(s)",
  "kendo.recurrenceeditor.dailyRepeatEvery": "Repetir cada:",
  "kendo.recurrenceeditor.endAfter": "Después",
  "kendo.recurrenceeditor.endLabel": "Fin:",
  "kendo.recurrenceeditor.endNever": "Nunca",
  "kendo.recurrenceeditor.endOccurrence": "ocurrencia(s)",
  "kendo.recurrenceeditor.endOn": "En",
  "kendo.recurrenceeditor.frequenciesDaily": "Diariamente",
  "kendo.recurrenceeditor.frequenciesMonthly": "Mensualmente",
  "kendo.recurrenceeditor.frequenciesNever": "Nunca",
  "kendo.recurrenceeditor.frequenciesWeekly": "Semanalmente",
  "kendo.recurrenceeditor.frequenciesYearly": "Anualmente",
  "kendo.recurrenceeditor.monthlyDay": "Día",
  "kendo.recurrenceeditor.monthlyInterval": "mes(es)",
  "kendo.recurrenceeditor.monthlyRepeatEvery": "Repetir cada:",
  "kendo.recurrenceeditor.monthlyRepeatOn": "Repetir en:",
  "kendo.recurrenceeditor.offsetPositionsFourth": "cuarto",
  "kendo.recurrenceeditor.offsetPositionsLast": "último",
  "kendo.recurrenceeditor.offsetPositionsSecond": "segundo",
  "kendo.recurrenceeditor.offsetPositionsThird": "tercero",
  "kendo.recurrenceeditor.repeat": "Repetir",
  "kendo.recurrenceeditor.weekdaysDay": "día",
  "kendo.recurrenceeditor.weekdaysWeekday": "día de semana",
  "kendo.recurrenceeditor.weekdaysWeekendday": "día de fin de semana",
  "kendo.recurrenceeditor.weeklyInterval": "semana(s)",
  "kendo.recurrenceeditor.weeklyRepeatEvery": "Repetir cada:",
  "kendo.recurrenceeditor.weeklyRepeatOn": "Repetir en:",
  "kendo.recurrenceeditor.yearlyInterval": "año(s)",
  "kendo.recurrenceeditor.yearlyOf": "de",
  "kendo.recurrenceeditor.yearlyRepeatEvery": "Repetir cada:",
  "kendo.recurrenceeditor.yearlyRepeatOn": "Repetir en:",
  "kendo.recurrenceeditor.numericIncrement": "Increase value",
  "kendo.recurrenceeditor.numericDecrement": "Decrease value",
  "kendo.recurrenceeditor.dateInputsToday": "Today",
  "kendo.recurrenceeditor.dateInputsToggle": "Toggle popup",
  "kendo.recurrenceeditor.dateInputsParentViewButton": "Navigate to parent view",
  "kendo.scheduler.agendaViewTitle": "Agenda",
  "kendo.scheduler.allDay": "todo el día",
  "kendo.scheduler.allEvents": "Todos los eventos",
  "kendo.scheduler.calendarToday": "HOY",
  "kendo.scheduler.cancel": "Cancelar",
  "kendo.scheduler.save": "Guardar",
  "kendo.scheduler.editorEventTitle": "Title",
  "kendo.scheduler.editorEventStart": "Start",
  "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
  "kendo.scheduler.editorEventEnd": "End",
  "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
  "kendo.scheduler.dateHeader": "Fecha",
  "kendo.scheduler.dayViewTitle": "Título",
  "kendo.scheduler.deleteConfirmation": "¿Está seguro que quiere eliminar este evento?",
  "kendo.scheduler.deleteDialogTitle": "Eliminar evento",
  "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
  "kendo.scheduler.deleteRecurringConfirmation": "Do you want to delete only this event occurrence or the whole series?",
  "kendo.scheduler.deleteRecurringDialogTitle": "¿Quiere eliminar esta ocurrencia del evento o la serie completa?",
  "kendo.scheduler.deleteSeries": "Eliminar la serie",
  "kendo.scheduler.deleteTitle": "Eliminar evento",
  "kendo.scheduler.destroy": "Eliminar",
  "kendo.scheduler.editOccurrence": "Editar ocurrencia actual",
  "kendo.scheduler.editorEventAllDay": "Todo el día",
  "kendo.scheduler.editorEventDescription": "Descripción",
  "kendo.scheduler.editorEventSeparateTimeZones": "Usar zonas horarias separadas para el inicio y el fin",
  "kendo.scheduler.editorEventTimeZone": "Zona horaria de fin",
  "kendo.scheduler.editorTitle": "Título",
  "kendo.scheduler.editRecurringConfirmation": "¿Quiere editar esta ocurrencia del evento o la serie completa?",
  "kendo.scheduler.editRecurringDialogTitle": "Editar elemento recurrente",
  "kendo.scheduler.editSeries": "Editar la serie",
  "kendo.scheduler.eventHeader": "Evento",
  "kendo.scheduler.monthViewTitle": "Mes",
  "kendo.scheduler.multiDayViewTitle": "Multi-Day",
  "kendo.scheduler.nextTitle": "Next",
  "kendo.scheduler.previousTitle": "Previous",
  "kendo.scheduler.recurrenceEditorDailyInterval": "día(s)",
  "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repetir cada:",
  "kendo.scheduler.recurrenceEditorEndAfter": "After",
  "kendo.scheduler.recurrenceEditorEndLabel": "End",
  "kendo.scheduler.recurrenceEditorEndNever": "Never",
  "kendo.scheduler.recurrenceEditorEndOccurrence": "ocurrencia(s)",
  "kendo.scheduler.recurrenceEditorEndOn": "On",
  "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Diariamente",
  "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Mensualmente",
  "kendo.scheduler.recurrenceEditorFrequenciesNever": "Nunca",
  "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Semanalmente",
  "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Anualmente",
  "kendo.scheduler.recurrenceEditorMonthlyDay": "Día",
  "kendo.scheduler.recurrenceEditorMonthlyInterval": "mes(es)",
  "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repetir cada:",
  "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repetir en:",
  "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "primero",
  "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "cuarto",
  "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "último",
  "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "segundo",
  "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "tercero",
  "kendo.scheduler.recurrenceEditorRepeat": "Repetir",
  "kendo.scheduler.recurrenceEditorWeekdaysDay": "día",
  "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "día de semana",
  "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
  "kendo.scheduler.recurrenceEditorWeeklyInterval": "semana(s)",
  "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repetir cada:",
  "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repetir en:",
  "kendo.scheduler.recurrenceEditorYearlyInterval": "año(s)",
  "kendo.scheduler.recurrenceEditorYearlyOf": "of",
  "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repetir cada:",
  "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repetir en:",
  "kendo.scheduler.showFullDay": "Mostrar día completo",
  "kendo.scheduler.showWorkDay": "Mostrar horas laborables",
  "kendo.scheduler.timeHeader": "Hora",
  "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
  "kendo.scheduler.timelineViewTitle": "Timeline",
  "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
  "kendo.scheduler.today": "Hoy",
  "kendo.scheduler.weekViewTitle": "Week",
  "kendo.scheduler.workWeekViewTitle": "Work Week",
  "kendo.scheduler.selectView": "Select View",
  "kendo.scheduler.editorDateInputsToday": "Today",
  "kendo.scheduler.editorDateInputsToggle": "Toggle popup",
  "kendo.scheduler.editorDateInputsParentViewButton": "Navigate to parent view",
  "kendo.scheduler.editorDateInputsNow": "NOW",
  "kendo.scheduler.editorDateInputsNowLabel": "Select now",
  "kendo.scheduler.editorDateInputsAccept": "Set",
  "kendo.scheduler.editorDateInputsAcceptLabel": "Set",
  "kendo.scheduler.editorDateInputsCancel": "Cancel",
  "kendo.scheduler.editorDateInputsCancelLabel": "Cancel",
  "kendo.scheduler.editorDateInputsDateTab": "Date",
  "kendo.scheduler.editorDateInputsDateTabLabel": "Date tab",
  "kendo.scheduler.editorDateInputsTimeTab": "Time",
  "kendo.scheduler.editorDateInputsTimeTabLabel": "Time tab",
  "kendo.scheduler.recurrenceEditorNumericIncrement": "Increase value",
  "kendo.scheduler.recurrenceEditorNumericDecrement": "Decrease value",
  "kendo.scheduler.recurrenceEditorDateInputsToday": "Today",
  "kendo.scheduler.recurrenceEditorDateInputsToggle": "Toggle popup",
  "kendo.scheduler.recurrenceEditorDateInputsParentViewButton": "Navigate to parent view",
  "kendo.scheduler.yearViewTitle": "Year",
  "kendo.scheduler.yearViewNoEvents": "No events on this date.",

  // Textbox
  'kendo.textbox.clear': 'Borrar',

  // NumericTextBox
  "kendo.numerictextbox.increment": "Incrementar valor",
  "kendo.numerictextbox.decrement": "Disminuir valor",

  // Dateinput
  "kendo.dateinput.increment": "Incrementar valor",
  "kendo.dateinput.decrement": "Disminuir valor",
  "kendo.dateinput.clearTitle": "Limpiar"
};

@Injectable()
export class GlobalKendoMessageService extends MessageService {
  public override get(key: string): string {
   return overridesEsAR[key] ?? key;
  }
}
